import { render, staticRenderFns } from "./ClipInfoCard.vue?vue&type=template&id=05fcd45c&scoped=true"
import script from "./ClipInfoCard.vue?vue&type=script&lang=js"
export * from "./ClipInfoCard.vue?vue&type=script&lang=js"
import style0 from "./ClipInfoCard.vue?vue&type=style&index=0&id=05fcd45c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fcd45c",
  null
  
)

export default component.exports